import { contentfulApi } from 'common/api/utils/contentful';
import { Subscription } from 'common/api/crm/family/types';
import { Notifications } from 'common/api/contentful/models/Notifications';
import { Entry } from 'contentful';

export const getContentfulEntriesForNotifications = async (): Promise<Entry<Notifications>[]> => {
    const result = await contentfulApi.getEntries<Notifications, unknown>({
        content_type: 'notifications',
    });
    if (result.data) {
        return result.data.items;
    }
    return [];
};

export const addSubtextToSubscriptions = (
    data: Subscription[],
    items: Entry<Notifications>[]
): Subscription[] => {
    return data.map((sub: Subscription) => {
        const entry = items.find((entry) => entry.fields.messageTypeId === sub.id);
        if (entry) {
            sub.subText = entry.fields.messageTypeDescription;
        }
        return sub;
    });
};
